import { Link } from 'react-router-dom';

export type Crumb = {
  label: string;
  to?: string;
};

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="w-full px-4 py-4 md:px-8">
      <ol className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
        <li>
          <Link to="/" className="transition-colors hover:text-primary-600">
            首页
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={`${item.label}-${index}`} className="flex items-center gap-2">
            <i className="ri-arrow-right-s-line text-background-300" aria-hidden="true"></i>
            {item.to ? (
              <Link to={item.to} className="transition-colors hover:text-primary-600">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}